import React from "react";
import { connect } from "react-redux";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared";

import useSecondaryParts from "@app/component/GlobalSearch/components/Item/useSecondaryParts";
import TextHighlighter from "@app/component/TextHighlighter";
import { getActiveQuery } from "@app/store/globalSearch/selectors";
import { getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";
import GlobalSearchItem from "@app/types/globalSearch/GlobalSearchItem";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { PersonFieldName } from "@app/util/fieldModel/PersonFieldModel";

import styles from "./Title.module.scss";

interface TitleProps {
  item: GlobalSearchItem;
}

const Title = ({ activeQuery, item, users }: TitleProps & ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();

  const secondaryPart = useSecondaryParts(item, users, activeQuery);

  const nameField = item.entityType
    ? // We don't really care about exact match of entity types here. If some other
      // type is used which doesn't have a field model, we'll get undefined,
      // which is totally fine and expected.
      // @ts-ignore
      getFieldModelByEntityType(item.entityType)?.getByName(
        item.entityType === EntityType.PERSON ? PersonFieldName.FIRST_NAME : "name"
      )
    : undefined;

  return (
    <div className={styles.container}>
      <div className={styles.mainPart}>
        <Tooltip
          title={intl.formatMessage({
            id: "component.globalSearch.title.hiddenNameTooltip",
            defaultMessage: "Protected Information",
            description:
              "Protected information tooltip in GlobalSearch result title when the name field is hidden",
          })}
          trigger={nameField && !nameField.isReadable ? ["hover"] : []}
        >
          <TextHighlighter searchText={activeQuery} text={item.title} />
        </Tooltip>
      </div>
      <div className={styles.secondaryPart}>{secondaryPart}</div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  activeQuery: getActiveQuery(state),
  users: getUsers(state),
});

export default connect(mapStateToProps)(Title);
